import { Navigate } from "react-router-dom";
import { logoutUser } from "../../utils/main-utils";
import { useDispatch } from "react-redux";
import { mainActions } from "../../store/main/mainSlice";

const Logout = () => {
  logoutUser();
  const dispatch = useDispatch();
  dispatch(mainActions.clearInvoice());
  return <Navigate to={{ pathname: "/" }} />;
};

export default Logout;
